import { clsx, type ClassValue } from "clsx";

/** Compose class names without inventing styling logic. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
